import getConfig from 'lib/next-config-compat';
import { useCallback, useEffect, useMemo } from 'react';
import TagManager from 'react-gtm-module';

const { publicRuntimeConfig } = getConfig();

// A GTM dataLayer push is an arbitrary JSON-serialisable object (the event name
// plus whatever that event carries), which is as specific as this gets.
type DataLayer = Record<string, unknown>;

const useDataLayer = (dataLayer?: DataLayer | null) => {
  const valid = !!dataLayer;
  // biome-ignore lint: next-line/react-hooks/exhaustive-deps
  const dataLayerJson = useMemo(() => JSON.stringify(dataLayer), [dataLayer]);

  const pushDataLayer = useCallback((dataLayer: DataLayer) => {
    if (publicRuntimeConfig.gtmId) {
      TagManager.dataLayer({ dataLayer });
    }
  }, []);

  const push = useCallback(() => {
    if (valid) {
      pushDataLayer(JSON.parse(dataLayerJson));
    }
  }, [pushDataLayer, dataLayerJson, valid]);

  useEffect(() => {
    push();
  }, [push]);

  return pushDataLayer;
};

export default useDataLayer;
